import * as React from 'react';
import { forwardRef } from 'react';
import { useTheme } from '../../../../theme';
const AirportTooltip = forwardRef(({ airport }, ref) => {
    const { AirportTooltip: css } = useTheme('FlightStatus');
    return (React.createElement("div", { ref: ref }, airport && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css.content },
            React.createElement("div", { className: css.name }, airport.name),
            React.createElement("div", { className: css.iata }, airport.iata))))));
});
export default AirportTooltip;
